import BannerShopService from '../services/banner.shop.service';

export const bannerShop = {
	namespaced: true,
	actions: {
		get() {
			return BannerShopService.get();
		}
	},
	mutations: {}
};
